export var ReportStatus;
(function (ReportStatus) {
    ReportStatus[ReportStatus["Pending"] = 0] = "Pending";
    ReportStatus[ReportStatus["Running"] = 1] = "Running";
    ReportStatus[ReportStatus["Complete"] = 2] = "Complete";
    ReportStatus[ReportStatus["Failed"] = 3] = "Failed";
})(ReportStatus || (ReportStatus = {}));
